export default class HistoryHelper {
  static setupPopState(callback) {
    window.addEventListener('popstate', callback);
  }

  static updateEntry(state, title, url) {
    history.replaceState(state, title, url);
  }
}
